import { ConfirmDialog } from '@gogame/components';
import { useMutation } from '@gogame/query';
import { useScreenModalV2 } from '@gogame/screens';

import { moreInfoSpendAdjustment } from 'scenes/SpendAdjustments/sources/spendAdjustment';

import { moreInfo } from '../queryKeyFactory';

export const useMoreInfoSA = () => {
  const showModal = useScreenModalV2(ConfirmDialog);
  const moreInfoMutation = useMutation(moreInfo(), moreInfoSpendAdjustment, {
    successMessage: () => `More info requested`,
  });
  const handleMoreInfo = async ({ id }) => {
    const comment = await showModal({
      title: 'Request More Info about the Spend Adjustment?',
      confirmActionLabel: 'Request More Info',
      withTextField: true,
      textFieldPlaceholder: 'Comment',
      textFieldRequired: false,
    });

    await moreInfoMutation.mutateAsync({ id, comment });
  };

  return [handleMoreInfo, moreInfoMutation];
};
